import { Component, OnInit } from '@angular/core';
import { Base64UrlService } from '../../../services/base64url.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
    selector: 'tt-br-reg',
    templateUrl: './br-reg.component.html',
    styleUrls: ['./br-reg.component.css'],
    standalone: false
})
export class BrRegComponent implements OnInit {
    public companyNameButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('companyname_search') },
        { id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.executeBrReg() }
    ];

    public naeringsKodeButtons: FormButton[] = [{ id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('naeringskode') }];

    public naeringsKodeEditButtons: FormButton[] = [{ id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('naeringskode') }];

    public countyButtons: FormButton[] = [{ id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('county_id') }];

    public communityButtons: FormButton[] = [{ id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('comunity_id') }];

    public setting?: Setting;

    public selectListNaces: NaceItem[] = [];

    public selectListCounties: CountyItem[] = [];

    public selectListCommunities: CommunityItem[] = [];

    public itemsListCompanies: Item[] = [];

    public loadingCompanies = false;

    constructor(private base64: Base64UrlService, private datatask: DataTaskService) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1304))[0];
    }

    private async loadNaces() {
        this.selectListNaces = await this.datatask.Post(1312);
    }

    private async loadCounties() {
        this.selectListCounties = await this.datatask.Post(1307);
    }

    private async loadCommunities() {
        if (!this.setting) return;

        return this.selectListCommunities = await this.datatask.Post(1308, { county_id: this.setting.county_id });
    }

    public async getUrl() {
        const response = (await this.datatask.Post(1309, this.setting))[0];

        this.loadingCompanies = true;

        const searchUrl = response?.search_url;

        fetch(searchUrl)
            .then((result) => {
                if (!result.ok) {
                    throw new Error(`HTTP error: ${result.status}`);
                }

                return result.text();
            })
            .then((responseText) => {
                return this.datatask.Post(1305, { response: this.base64.urlEncode(responseText) });
            })
            .then((list) => {
                this.loadingCompanies = false;
                this.itemsListCompanies = list;
            })
            .catch(() => this.loadingCompanies = false);
    }

    private async executeBrReg() {
        if (!this.setting) return;

        const companySearch = 'https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + this.setting.companyname_search;

        fetch(companySearch)
            .then((result) => {
                if (!result.ok) {
                    throw new Error(`HTTP error: ${result.status}`);
                }

                return result.text();
            })
            .then((responseText) => {
                return this.datatask.Post(1305, { response: this.base64.urlEncode(responseText) });
            })
            .then((list) => this.itemsListCompanies = list);
    }

    private clear(id: string) {
        if (!this.setting && !this.itemsListCompanies) return;

        switch (id) {
            case 'naeringskode':
            case 'comunity_id':
                this.setting![id] = '';
                break;
            case 'county_id':
                this.setting!.county_id = '';
                this.setting!.comunity_id = '';
                this.selectListCommunities = [];
                break;
            case 'companyname_search':
                this.setting!.companyname_search = '';
                this.itemsListCompanies = [];
                break;
            default:
                break;
        }
    }

    public async searchItems() {
        this.executeBrReg();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'county_id':
                this.loadCommunities();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadNaces();
        this.loadCounties();
        this.loadCommunities();
        this.executeBrReg();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    companyname_search: string;
    county_id: string;
    comunity_id: string;
    fraAntallAnsatte: string;
    naeringskode: string;
}

interface NaceItem {
    nace_id: string;
    nace_name: string;
    orderby: string;
}

interface CountyItem {
    county_id: string;
    county_name: string;
    orderby: string;
}

interface CommunityItem {
    comunity_id: string;
    comunity_name: string;
    orderby: string;
}
